///
/// EarthBrowser Admin Dashboard - System Management API
///
/// Created: 2025-12-13
/// Copyright (c) 2025 Geodata Labs
///

import { authenticatedApi } from './authenticatedApi'

export interface ClearCacheResponse {
  message: string
}

export const systemApi = authenticatedApi.injectEndpoints({
  endpoints: (builder) => ({
    clearOGCCache: builder.mutation<ClearCacheResponse, void>({
      query: () => ({
        url: '/api/v1/ogc/features/admin/cache/clear',
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useClearOGCCacheMutation,
} = systemApi

